import { NEW_ENDPOINTS } from '@constants'
import { ISingleDocument, PaymentStatus, QuotationStatus } from '@typings'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { BaseApi } from './_base.api'

export class DocumentsApi extends BaseApi {
  getAll = (params?: AxiosRequestConfig['params']) =>
    this.api.get(NEW_ENDPOINTS.DOCUMENTS.LIST, params).then(res => res.data)

  downloadPdf = (id: ISingleDocument['id']) => this.download.get(NEW_ENDPOINTS.DOCUMENTS.DOWNLOAD(id)).then(res => res)

  downloadBulkPdf = (documentIds: number[]) =>
    this.download
      .post('/documents/bulk-download', JSON.stringify({ document_ids: documentIds }), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(res => res)

  getSingle = (id: ISingleDocument['id'], params?: AxiosRequestConfig['params']) =>
    this.api.get<AxiosResponse<ISingleDocument>>(NEW_ENDPOINTS.DOCUMENTS.SINGLE(id), params).then(res => res.data.data)

  finalise = (id: ISingleDocument['id'], data: ISingleDocument) =>
    this.api.patch(NEW_ENDPOINTS.DOCUMENTS.FINALISE(id), data).then(res => res.data.data)

  updateStatus = (id: ISingleDocument['id'], data: { payment_status: PaymentStatus }) =>
    this.api.patch(`/documents/${id}/status`, data).then(res => res.data.data)

  updateQuotationStatus = (
    id: ISingleDocument['id'],
    data: { quotation_status: QuotationStatus; quotation_status_comment?: string }
  ) => this.api.patch(`/documents/${id}/quotation-status`, data).then(res => res.data.data)

  getQuotationStatusHistory = (id: ISingleDocument['id']) =>
    this.api.get(`/documents/${id}/quotation-status-history`).then(res => res.data.data)

  createCreditNote = (id: ISingleDocument['id']) => this.api.post(`/documents/${id}/credit`).then(res => res.data.data)

  duplicate = (
    id: ISingleDocument['id'],
    data?: { reference?: string; subject?: string; client_id?: number; type?: string }
  ) => this.api.post(`/documents/${id}/duplicate`, data || {}).then(res => res.data.data)

  create = (data: Partial<ISingleDocument>) =>
    this.api.post(NEW_ENDPOINTS.DOCUMENTS.LIST, data).then(res => res.data.data)

  update = (id: ISingleDocument['id'], data: ISingleDocument) =>
    this.api.put(NEW_ENDPOINTS.DOCUMENTS.SINGLE(id), data).then(res => res.data.data)

  delete = (id: ISingleDocument['id']) => this.api.delete(NEW_ENDPOINTS.DOCUMENTS.SINGLE(id))

  deleteBulk = (documentIds: number[]) =>
    this.api.delete(NEW_ENDPOINTS.DOCUMENTS.BULK_DELETE, {
      data: { ids: documentIds },
    })
}
